import { compact, keyBy, omit, reduce } from 'lodash'

import {
  FETCH_DEVICES,
  FETCH_DEVICE,
  DELETE_DEVICE,
  CREATE_DEVICE,
  UPDATE_DEVICE,
  SET_DEVICE_FILTER,
} from './actionTypes'

const initialState = { byId: {}, filters: { status: 'registered' } }

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_DEVICES: {
      const deviceRefreshes = keyBy(compact(payload.devices), 'deviceId')
      const refreshedDevices = reduce(
        state.byId,
        (devices, device) => {
          const deviceId = device?.deviceId

          if (!deviceId || !devices[deviceId]) {
            return devices
          }

          devices[deviceId] = {
            ...device,
            ...devices[deviceId],
          }

          return devices
        },
        deviceRefreshes
      )

      return {
        ...state,
        byId: refreshedDevices,
      }
    }

    case FETCH_DEVICE: {
      const updatedById = payload.deviceId
        ? { ...state.byId, [payload.deviceId]: payload }
        : { ...state.byId }

      return {
        ...state,
        byId: updatedById,
      }
    }

    case DELETE_DEVICE: {
      return {
        ...state,
        byId: omit(state.byId, payload.deviceId),
      }
    }

    case UPDATE_DEVICE: {
      const updatedById = payload.deviceId
        ? { ...state.byId, [payload.deviceId]: payload }
        : { ...state.byId }

      return {
        ...state,
        byId: updatedById,
      }
    }

    case CREATE_DEVICE: {
      const updatedById = payload.deviceId
        ? { ...state.byId, [payload.deviceId]: payload }
        : { ...state.byId }

      return {
        ...state,
        byId: updatedById,
      }
    }

    case SET_DEVICE_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          [payload.name]: payload.value,
        },
      }
    }

    default:
      return state
  }
}
